import TitleBar5 from './titleBar5';
export default TitleBar5;
